import { alpha } from "@mui/material"
import { blueGrey } from "../../../../themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ palette }) => ({
  banner: {
    display: "flex",
    alignItems: "center",
    borderRadius: "0px"
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",

    "& button": {
      color: palette.common.white,

      "&:disabled": {
        color: alpha(palette.common.white, 0.5)
      },
      "&:hover": {
        color: palette.common.white,
        backgroundColor: alpha(blueGrey[50], 0.2)
      },
      "&:focus": {
        color: palette.common.white,
        backgroundColor: alpha(blueGrey[50], 0.2)
      }
    }
  }
}))
